export default {
  name: "App",
  created() {}
};